import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { flow, makeObservable, observable, runInAction } from "mobx";
import { request } from "../utils/request.js";
import { locationRestTemplatesServiceUseGet } from "../wp-api/templatesServiceUse.get.js";
class ServiceTemplate {
    busy = false;
    data;
    use;
    store;
    constructor(template, store){
        makeObservable(this);
        runInAction(()=>{
            this.data = template;
        });
        this.store = store;
    }
    fetchUse = flow(function*() {
        try {
            this.busy = true;
            const response = yield request({
                location: locationRestTemplatesServiceUseGet,
                params: {
                    identifier: this.data.identifier
                }
            });
            this.use = response;
            return this.use;
        } catch (e) {
            console.log(e);
            throw e;
        } finally{
            this.busy = false;
        }
    });
}
_ts_decorate([
    observable
], ServiceTemplate.prototype, "busy", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], ServiceTemplate.prototype, "data", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", typeof ResponseRouteTemplatesServiceUseGet === "undefined" ? Object : ResponseRouteTemplatesServiceUseGet)
], ServiceTemplate.prototype, "use", void 0);
export { ServiceTemplate };
